import React from 'react';

interface LogoProps {
  className?: string;
  showText?: boolean;
  animate?: boolean;
}

export function Logo({ className = "w-10 h-10", showText = false, animate = false }: LogoProps) {
  const combinedClassName = `${className} ${animate ? 'animate-spin' : ''}`;
  
  return (
    <div className="flex items-center space-x-3">
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={combinedClassName}
        style={{ filter: 'drop-shadow(0px 4px 6px rgba(147, 51, 234, 0.3))' }}
      >
        {/* Main Logo Shape - Hexagon with gradient stroke */}
        <path
          d="M50 5L87.3013 25V65L50 85L12.6987 65V25L50 5Z"
          fill="url(#gradient-primary)"
          className="drop-shadow-lg"
        />

        {/* Inner Form Shape */}
        <path
          d="M50 20L72.6506 32.5V57.5L50 70L27.3494 57.5V32.5L50 20Z"
          fill="white"
          fillOpacity="0.95"
          className="drop-shadow-sm"
        />

        {/* AI Circuit Lines */}
        <path
          d="M35 40H65M40 50H60M45 60H55"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          className="text-purple-600"
        />

        {/* Animated Elements */}
        <circle
          cx="35"
          cy="40"
          r="2"
          fill="#9333EA"
          opacity="0.8"
          className={animate ? 'animate-pulse' : ''}
        />
        <circle
          cx="65"
          cy="40"
          r="2"
          fill="#9333EA"
          opacity="0.8"
          className={animate ? 'animate-pulse' : ''}
          style={{ animationDelay: '0.5s' }}
        />

        {/* Gradient Definitions */}
        <defs>
          <linearGradient
            id="gradient-primary"
            x1="12.6987"
            y1="25"
            x2="87.3013"
            y2="85"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#9333EA" />
            <stop offset="100%" stopColor="#6366F1" />
          </linearGradient>
        </defs>
      </svg>

      {showText && (
        <span className="text-xl font-bold bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent whitespace-nowrap">
          AINativeForms
        </span>
      )}
    </div>
  );
} 